// @flow
import React from 'react';
import './App.css';
import E404 from './Errors/E404';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Privacy from './Pages/Privacy';
import TnCs from './Pages/TnCs';
import './assets/fonts/fonts.css';
import { MediaQueryProvider } from 'react-media-query-hoc';
import Home from './Pages/Home';

// $FlowFixMe
export default function (props: {}): React.DOM {
  return (
    <MediaQueryProvider>
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={Home}/>
          <Route path="/privacy-policy" component={Privacy}/>
          <Route path="/terms-and-conditions" component={TnCs}/>
          <Route component={E404}/>
        </Switch>
      </BrowserRouter>
    </MediaQueryProvider>
  );
};



// WEBPACK FOOTER //
// ./src/App.js